// extracted by mini-css-extract-plugin
export default {"small":"TextAreaLayout_small__QSC5X"};